import { useEffect } from 'react';

import { PageHeader, Breadcrumbs, Table, Link, Loader, Alert, useNotify } from '@hotjar/hotsauce';
import { useTranslation, Trans, useHelpHotjarUrl } from '@hotjar/translations';
import { PROFILE } from '@hotjar/webapp/constants/routes';
import { useQuery } from 'react-query';
import { getLoginEvents } from '../../domains/profile/api';
import { InfoText, Page, PageSection } from './styles';
import { LoginEventTableRow } from './LoginEventTableRow';

export function SignInActivity(): JSX.Element {
  const { t } = useTranslation('profile');
  const helpHotjarUrl = useHelpHotjarUrl();
  const { data, isLoading, error } = useQuery('profile/signin-activity', getLoginEvents);
  const { showToast } = useNotify();

  useEffect(() => {
    if (!isLoading && Boolean(error)) {
      showToast({ kind: 'danger', text: 'Something went wrong loading your activities' });
    }
  }, [isLoading, error, showToast]);

  const hasLoginEvents = !!data && data.events !== undefined && data.events.length > 0;

  return (
    <Page>
      <PageHeader
        title={t('sign-in-activity.title')}
        breadcrumbItems={[
          <Breadcrumbs.Item href={PROFILE.DETAILS.path} key="profile-details">
            {t('sign-in-activity.account-security')}
          </Breadcrumbs.Item>,
        ]}
      />

      <PageSection>
        <InfoText>
          <Trans t={t} i18nKey="sign-in-activity.description">
            <Link kind="inline" href={helpHotjarUrl}>
              {t('sign-in-activity.contact')}
            </Link>
          </Trans>
        </InfoText>
        <Loader isLoading={isLoading} size="xl" aria-label="Loading account activities">
          {hasLoginEvents ? (
            <Table caption="Caption" tableName="Table Name">
              <Table.Head>
                <Table.HeadRow>
                  <Table.HeadCell>Session type</Table.HeadCell>
                  <Table.HeadCell>Location</Table.HeadCell>
                  <Table.HeadCell>Time</Table.HeadCell>
                </Table.HeadRow>
              </Table.Head>
              <Table.Body>
                {data.events.map((loginEvent) => (
                  <LoginEventTableRow key={loginEvent.timestamp} loginEvent={loginEvent} />
                ))}
              </Table.Body>
            </Table>
          ) : (
            <Alert kind="info">No activities found</Alert>
          )}
        </Loader>
      </PageSection>
    </Page>
  );
}
